import { useLocalStorage } from '@/hooks/browser/use-local-storage';
import { useAnalytics } from '@/services/analytics';
import { Banner, Box, Button } from '@customerio/pluma-components/react';
import { addCopilotInstruction } from '@customerio/hydra-copilot';
import { usePrimaryCopilotSession } from '@customerio/hydra-copilot/react';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';

export function Tour() {
  const [isDismissed, setIsDismissed] = useLocalStorage('copilot-tour-hidden', false);
  const { track } = useAnalytics();
  const session = usePrimaryCopilotSession();
  const isV2 = useFeatureFlag(AccountFeatureFlag.AiAssistantV2);

  if (isDismissed || session == null || isV2) {
    return null;
  }

  const handleTakeTour = async () => {
    setIsDismissed(true);
    track('aiAssistant', 'tourStarted', { 'Tour Name': 'Metrics Analysis' });

    let cleanup: (() => void) | undefined;

    try {
      // Add the instruction temporarily
      cleanup = addCopilotInstruction({
        instruction: `If the user asks what they can do with the new metrics analysis capabilities, explain some of the functionality of your 'metrics' tool and give them a few examples of what they can do with it. Don't refer to it as tool or tools in your reply.`,
      });

      await session.sendMessage('What can I do with the new metrics analysis capabilities?');
    } finally {
      // Always remove the instruction, even if sendMessage fails
      cleanup?.();
    }
  };

  const handleNotNow = () => {
    setIsDismissed(true);
    track('aiAssistant', 'tourDismissed', { 'Tour Name': 'Metrics Analysis' });
  };

  return (
    <Box p="100">
      <Banner title="Understand Your Campaign Metrics" variant="feature">
        <Box display="flex" flexDirection="column" gap="125">
          Your assistant can now fetch and display key metrics for your campaigns, newsletters, and API-triggered
          broadcasts. Ready to explore your data?
          <Box display="flex" gap="100" alignItems="center">
            <Button size="sm" variant="primary" onClick={handleTakeTour}>
              Take a tour
            </Button>
            <Button size="sm" variant="subtle" onClick={handleNotNow}>
              Not now
            </Button>
          </Box>
        </Box>
      </Banner>
    </Box>
  );
}
